export const plans = [
  {
    id: 'plus',
    title: 'Strategist Advisor',
    description: 'An expert AI Advisor  for deeper insights and smarter solutions across domains',
    action: 'Upgrade',
  },
  {
    id: 'free',
    title: 'Advisor',
    description: 'Your trusted AI Advisor for quick, clear answers across domains.',
    selected: true,
  },
];

export function formatDateLabel(dateStr) {
  const today = new Date();
  const date = new Date(dateStr);
  const diffTime = today - date;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "Today";
  if (diffDays <= 7) return "Previous 7 Days";
  return "Previous 30 Days";
}

export const isToday = (dateStr) => {
  const date = new Date(dateStr);
  const today = new Date();
  return date.toDateString() === today.toDateString();
};

export const isLast7Days = (dateStr) => {
  const date = new Date(dateStr);
  const today = new Date();
  const diff = (today - date) / (1000 * 60 * 60 * 24);
  return diff > 0 && diff <= 7 && !isToday(dateStr);  // Exclude today
};

export const isLast30Days = (dateStr) => {
  const date = new Date(dateStr);
  const today = new Date();
  const diff = (today - date) / (1000 * 60 * 60 * 24);
  return diff > 7 && diff <= 30 && !isLast7Days(dateStr);  // Exclude last 7 days
};

export function combineCategoriesWithSubcategories(categories, subCategories) {
  return categories.map(category => {
    const matchingSubCategories = subCategories
      .filter(sub => sub.CategoryID === category.CategoryID)
      .map(sub => ({
        ...sub,
        ImageIcon: sub.ImageIcon
      }));

    return {
      ...category,
      ImageIcon: category.ImageIcon,
      SubCategories: matchingSubCategories
    };
  });
}


export function formatCustomDate(dateString) {
  const date = new Date(dateString);

  const day = date.getDate();
  const daySuffix = (d) => {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  const formattedHours = hours % 12 || 12; // convert 0 to 12
  const formattedMinutes = minutes.toString().padStart(2, '0');

  return `${day}${daySuffix(day)} ${monthNames[date.getMonth()]} ${date.getFullYear()}, ${formattedHours}:${formattedMinutes} ${ampm}`;
}
